import OverlayScrollbars, { DirectionChangedArgs, OverflowAmountChangedArgs, OverflowChangedArgs, SizeChangedArgs, UpdatedArgs } from "overlayscrollbars";

import { doNothing } from "@multiweb/reactUtils";

type OverlayScrollbarsExtensionEventArgs = UIEvent | OverflowChangedArgs | OverflowAmountChangedArgs | DirectionChangedArgs | SizeChangedArgs | UpdatedArgs;

export const PADDING_EXTENSION_NAME = "paddingExtension";

/**
 * Funkce zajišťující zobrazení/skrytí paddingu pro thumb scrollbaru
 */
const overlayScrollbarAdjuster = (osInstance: OverlayScrollbars, args?: OverlayScrollbarsExtensionEventArgs) => {
    let xScrollable: boolean;
    let yScrollable: boolean;

    if (!args) {
        const osInstanceState = osInstance.getState();

        if (!osInstanceState)
            return;

        xScrollable = osInstanceState.hasOverflow.x;
        yScrollable = osInstanceState.hasOverflow.y;
    } else {
        xScrollable = (args as any).xScrollable;
        yScrollable = (args as any).yScrollable;
    }

    const options = osInstance.options();
    const showXScrollbar = !(options && options.overflowBehavior && options.overflowBehavior.x === "hidden");
    const showYScrollbar = !(options && options.overflowBehavior && options.overflowBehavior.y === "hidden");

    const instanceElements = osInstance.getElements();
    const paddingElement = instanceElements.padding;

    const addClassNameMethod = paddingElement.classList.add;
    const removeClassNameMethod = paddingElement.classList.remove;

    const setClassName = (booleanValue: boolean, className: string) => {
        (booleanValue ? addClassNameMethod : removeClassNameMethod).bind(paddingElement.classList)(className);
    };

    setClassName(xScrollable && showXScrollbar, "os-padding--horizontal-padding");
    setClassName(yScrollable && showYScrollbar, "os-padding--vertical-padding");
};

/**
 * Zaregistruje rozšíření knihovny overlayscrollbars, které při změnách velikosti okna,
 * cílového elementu nebo změně overflow elementu dynamicky přidává nebo odebírá padding
 * na straně/spodu elementu, ve kterém se zobrazuje thumb scrollbaru.
 *
 * Pokud se má toto rozšíření použít, dá se předat cílovému elementu názvem (PADDING_EXTENSION_NAME)
 * při inicializaci přes prop `extensions`.
 */
export const registerPaddingExtension = () => {
    OverlayScrollbars.extension(PADDING_EXTENSION_NAME, function(_defaultOptions, _framework, _compatibility) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const osInstance = this;

        return {
            contract: (_global: any): boolean => {
                return true;
            },
            added: doNothing,
            removed: doNothing,
            on: (callbackName, args) => {
                switch (callbackName) {
                    case "overflowChanged":
                        overlayScrollbarAdjuster(osInstance, args);
                        break;
                    case "updated":
                        overlayScrollbarAdjuster(osInstance);
                        break;
                }
            },
        };
    });
};
